<template>
  <div>
    <div class="yu-flex yu-flex-start">
      <el-upload
        ref="upload"
        :show-file-list="false"
        :on-success="handleSuccess"
        :on-progress="handleProgress"
        :before-upload="beforeAvatarUpload"
        :auto-upload="true"
        :file-list="fileList"
        :limit="limit"
        :accept="accept.join(',')"
        :action="importFileUrl"
      >
        <div>
          <el-button :disabled="!shwoUploadBtn" size="mini" type="primary"
            ><i class="icon-ccui-add-sup"></i>上传支付凭证
          </el-button>
          <span style="color: #4A4A4A; margin-left: 20px;"
            >支持{{ accept.join(",") }}格式文件上传</span
          >
        </div>
      </el-upload>
      <div class="image-box" v-for="(el, index) in fileList" :key="index">
        <img
          :src="getPoster(el)"
          :alt="el.fileName"
          style="width: 100%; height: 100%;"
        />
        <div class="img-close" @click.stop="onFileDelete(index)">
          <i class="icon-ccui-add-sup"></i>
        </div>
        <div style="color: #4A4A4A; font-size: 12px;">{{ el.fileName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from "ccui";
import imgBase64 from "@/views/business-open-shop/components/img-base64";
export default {
  props: {
    type: {
      type: String,
      default: "other"
    },
    accept: {
      type: Array,
      default: () => [".pdf", ".xls", ".xlsx", ".doc", ".docx"]
    },
    fileSize: {
      type: [String, Number],
      default: 15
    },
    size: {
      type: Array,
      default: () => []
    },
    action: {
      type: String,
      default: "/apis/sra/reg/users/signup/uploadFileToOss"
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  computed: {
    importFileUrl() {
      return this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) + this.action;
    },
    shwoUploadBtn() {
      return this.fileList.length < this.limit;
    }
  },
  data() {
    return {
      fileList: [],
      loadingObj: null,
      titleData: {}
    };
  },
  methods: {
    setFileList(list) {
      console.log(list, "*-*-fileList*-*");
      this.fileList = list;
    },
    // 附件信息成功的时触发
    handleSuccess(response, file, fileList) {
      console.log(response);
      if (response.code === "0") {
        this.$message({
          type: "success",
          message: "文件上传成功！",
          offset: document.body.clientHeight / 2 - 21
        });
        this.fileList.push(response.data[0]);

        this.$emit("success", this.fileList);
      } else {
        this.$message({
          type: "error",
          message: "文件上传失败！",
          offset: document.body.clientHeight / 2 - 21
        });
      }
      if (this.loadingObj) {
        this.loadingObj.close();
      }
    },
    onFileDelete(index) {
      this.fileList.splice(index, 1);
      console.log(this.fileList.length, "删除后的fileList");
      this.$emit("success", this.fileList);
    },
    handleProgress(event) {
      this.loadingObj = Loading.service({
        lock: true,
        text: `正在上传...`,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
    },
    beforeAvatarUpload(file) {
      console.log(file, "上传文件***-*--*-");
      const listFileSize = file.size / 1024 / 1024;
      if (listFileSize > this.fileSize) {
        this.$message({
          type: "error",
          message: `上传图片大小不能超过 ${this.fileSize}MB!`,
          offset: document.body.clientHeight / 2 - 21
        });
        return false;
      } else {
        const fileType = "." + file.name.match(/\.(\w+)$/)[1];
        if (!this.accept.includes(fileType.toLowerCase())) {
          this.$message({
            type: "error",
            message: `上传文件支持格式：${this.accept.join(",")}`,
            offset: document.body.clientHeight / 2 - 21
          });
          return false;
        } else if (this.size.length == 2) {
          const _this = this;
          const isSize = new Promise((resolve, reject) => {
            const img = new Image();
            const _URL = window.URL || window.webkitURl;
            img.onload = () => {
              file.width = img.width; //图片宽度
              file.height = img.height; //图片高度
              const valid =
                img.width <= _this.size[0] && img.height <= _this.size[1]; //上传图片尺寸判定
              valid ? resolve() : reject(new Error("error"));
            };
            img.src = _URL.createObjectURL(file);
          }).then(
            () => {
              return file;
            },
            () => {
              _this.$message({
                showClose: true,
                type: "error",
                message: `上传图片尺寸必须在${_this.size[0]}*${_this.size[1]}以内！`,
                ccuiCustom: true
              });
              return Promise.reject(new Error("error"));
            }
          );
          return isSize;
        }
      }
      return true;
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file, "水电费水电费");
      this.imageUrl = URL.createObjectURL(file.raw);
      this.form.uploadId = res.data[0].uploadId;
      this.form.shopLogoUrl = res.data[0].downloadUrl;
    },

    getPoster(file) {
      const filetype = file.fileName.match(/\.(\w+)$/)[1];
      const imgtype = ["png", "jpg", "jpeg", "gif"];

      const poster = [
        {
          type: "docx",
          icon: imgBase64.doc
        },
        {
          type: "pdf,PDF",
          icon: imgBase64.pdf
        },
        {
          type: "xlsx,XLSX",
          icon: imgBase64.xls
        },
        {
          type: "txt,TXT",
          icon: imgBase64.txt
        }
      ];
      if (imgtype.includes(filetype)) {
        return file.downloadUrl;
      } else if (poster.find(el => el.type.includes(filetype))) {
        return poster.find(el => el.type.includes(filetype)).icon;
      } else {
        return file.downloadUrl;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.image-box {
  width: 200px;
  height: 150px;
  margin-top: 20px;
  position: relative;
  border: 1px solid #dfdfdf;
  color: #b1b1b1;
  font-size: 24px;
  .img-close {
    position: absolute;
    top: -6px;
    right: -2px;
    font-size: 24px;
    transform: rotate(45deg);
    cursor: pointer;
  }
}
.logo-box {
  width: 65px;
  height: 65px;
  border: 1px dashed #979797;
}
.bgd {
  background: #f1f1f1;
}
.yu-flex-col {
  flex-direction: column;
}
</style>
